import React, { useEffect, useState } from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import PriceSummarySection from '../IdfSaleBlock/Constans/PriceSummarySection/PriceSummarySection';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import Checkbox from 'app/Components/Shared/CheckBox/Checkbox';
import { GetCreditCardTypeId, formatActivityHours } from '../IdfSaleBlock/IdfSaleEnums';
import usePageCapture from '../../../utilities/hooks/usePageCapture';
import useSaveToCalender from '../../../utilities/hooks/useSaveToCalender';
import BtnWhiteBlackBorderSmallSize from '../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import { useDispatch } from 'react-redux';
import { GetOrderDetails, pushToHistory, saveToHistory } from '../IdfSaleBlock/IdfSaleSlice';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { connect } from 'react-redux';

const OrderSummary = (props) => {

  useEffect(() => {
    props.pushToHistory("");
    return () => {
      props.saveToHistory("");
    }
  }, []);

  const dispatch = useDispatch();
  const [mailError, setMailError] = useState(null);
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);
  const { idfStore: store } = props;
  const { auth } = props;
  const { captureRef, capturePage } = usePageCapture();
  const isCourier = store.orderDetails.deliveryTypeId == 'Courier';

  const convertPackageTitle = (packageTitle) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = packageTitle;
    const textContent = tempElement.textContent || tempElement.innerText;
    return textContent;
  };

  var payMentCountInt = 0;
  var totalPriceNumber = 0;
  var isEsimOrder = !isNullOrEmpty(store.userDetails.esim_sap_order_no);
  var productsArr = [{
    name: isEsimOrder ? 'ESim' : 'Sim',
    price: 0,
    monthly: false,
  }];
  if (store.orderDetails.orderModel?.phoneModelId != 0) {
    payMentCountInt = parseInt(store.orderDetails.orderModel?.payMentCountInt, 10);
    totalPriceNumber = parseFloat(store.orderDetails.orderModel?.modelPrice);
    let monthlyPrice;
    if (payMentCountInt !== 0) {
      monthlyPrice = parseFloat((totalPriceNumber / payMentCountInt).toFixed(2));
    } else {
      monthlyPrice = 0; // Default value in case of division by zero
    }
    productsArr = [...productsArr,
    // Use spread operator to conditionally include the second object
    ...(store.processType === 'DEVICE'
      ? [
        {
          name: `${store.orderDetails.orderModel.modelName}GB`,
          price: totalPriceNumber.toFixed(2),
          monthlyPrice: monthlyPrice,
          payments: payMentCountInt,
          monthly: true,
        },
      ]
      : []), // Ensure this is an array to use with the spread operator
    ];

    store.orderDetails.orderModel?.isInterestedInWarranty &&
      monthlyProductsArr.push({
        name: 'שירות תיקונים בסיסי',
        price: warrantyPriceToInt,
        monthly: false,
      });

  }
  const { user_type_id: userType } = props.idfStore.userDetails;

  const warrantyPriceToInt = 24;
  const packagePricePostFunding = parseFloat(
    store.orderDetails.internetPackagePrice - parseInt(store.userDetails?.amount_of_funding, 10),
  ).toFixed(2);
  const monthlyProductsArr = [
    {
      name: convertPackageTitle(store.orderDetails?.internetPackageName),
      price: parseFloat(packagePricePostFunding) < 0 ? 0 : packagePricePostFunding,
      monthly: false,
    },
  ];


  const paymentInfo = {
    cardType: store.orderDetails?.creditCardTypeId,
    last4Digits: store.orderDetails?.creditLast4Digit,
    expirationDate: `${store.orderDetails?.creditCardMonth}/${store.orderDetails?.creditCardYear}`,
    id: store.userDetails?.id_number,
  };

  const getTime = (date) => {
    const time = date.split(" ")[1];
    const [hours, minutes, seconds] = time.split(":");
    return `${hours}:${minutes}`
  }

  const getDate = (dateString) => {
    const date = dateString.split(" ")[0];
    const [day, month, year] = date.split("/");
    return new Date(year, month - 1, day).toLocaleDateString('en-GB');
  };
  const deliveryAddressInfo = store.orderDetails.deliveryAddress;
  const deliveryInfo = isCourier && {
    deliveryHebrewDayOfTheWeek: deliveryAddressInfo.hebrewDay,
    deliveryDate: getDate(deliveryAddressInfo.deliveryStartTime),
    deliveryRange: [getTime(deliveryAddressInfo.deliveryStartTime), getTime(deliveryAddressInfo.deliveryEndTime)],
    address: `${deliveryAddressInfo.deliveryStreetName + ' ' + deliveryAddressInfo.deliveryHouseNo} ,${deliveryAddressInfo?.deliveryHouseEntrance !== ' ' ? deliveryAddressInfo?.deliveryHouseEntrance + ',' : ''
      } דירה ${deliveryAddressInfo?.deliveryAddressAptNo},  ${deliveryAddressInfo?.deliveryCityName}`,
    recipientName: store?.deliverySelectedFirstName + ' ' + store?.deliverySelectedLastName,
    recipientPhoneNumber: store?.deliverySelectedPhoneNumber,
  };
  const handleAddToCalenderClick = () => {
    const calendarSettings = {
      deliverySlots: store.selectedDeliverySlot,
    };
    useSaveToCalender(calendarSettings);
  };

  function getCustomerNewNumber() {
    let customerNewNumber =
      !isNullOrEmpty(store.userDetails.existing_line_code) ?
        store.userDetails.existing_line_code.padStart(10, '0') :
        !isNullOrEmpty(store.orderDetails.phoneInsertNumber) ?
          store.orderDetails.phoneInsertNumber :
          store.userDetails.new_line_code.padStart(10, '0');
    return customerNewNumber;
  }

  function PriceInformation(props) {
    return (
      <div className='price-information-container'>
        <span className='main-title'>{props.title}</span>
        <div className='products-container'>
          {props.subTitle && <span className='sub-title'>{props.subTitle}</span>}
          {props.arr.map((p) => (
            <div className='product-container'>
              <div className='full-price'>
                <span className='name'>{p.name}</span>
                <span className='price'>{'₪' + p.price}</span>
              </div>
              {p.monthly && (
                <span className='monthly-price' dir='ltr'>
                  {` ${p.payments} X  ₪${p.monthlyPrice} `}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
  function TotalPrice(props) {
    return (
      <div className='total-price-container'>
        <span>{props.title}</span>
        <span>₪{props.totalPrice}</span>
      </div>
    );
  }
  function getTotalPrice(Arr) {
    console.log(Arr);
    let totalPrice = 0;
    Arr.forEach((element) => {
      const priceToInt = parseFloat(parseFloat(element.price).toFixed(2));
      totalPrice += priceToInt;
    });
    return totalPrice;
  }


  return (

    <div className='main-container step' dir='rtl' ref={captureRef}>
      <div className='order-summary-container'>
        <div className='title-container'>
          <span className='main-title'>איזה כיף שהצטרפת אלינו!</span>
        </div>
        <div className='subscriber-no-container'>
          <span className='field-title'>מנוי {getCustomerNewNumber()} </span>
        </div>
        <div className='divider'></div>

        {store.processType === 'DEVICE' && (
          <PriceInformation title={'חיוב בגין ציוד'} subTitle={'מוצרים'} arr={productsArr}></PriceInformation>
        )}
        {store.processType === 'DEVICE' && (
          <TotalPrice title={'סה״כ חיוב בגין ציוד'} totalPrice={getTotalPrice(productsArr)}></TotalPrice>
        )}
        <div className='divider'></div>
        <PriceInformation title={'חיובים חודשיים'} subTitle={''} arr={monthlyProductsArr}></PriceInformation>
        <TotalPrice title={'סה״כ חיוב חודשי'} totalPrice={getTotalPrice(monthlyProductsArr)}></TotalPrice>
        <div className='divider'></div>

        <PriceSummarySection title='פרטי אמצעי תשלום' />
        <div className='info'>
          <span>סוג כרטיס: {GetCreditCardTypeId(paymentInfo?.cardType)}</span>
          <span>מספר כרטיס: {paymentInfo?.last4Digits} **** **** ****</span>
          <span>תוקף: {paymentInfo?.expirationDate}</span>
          <span>מספר ת.ז: {paymentInfo?.id}</span>
        </div>

        {/* Delivery info */}
        {(store.orderDetails.deliveryTypeId != 0) && (
          <>
            <div className='divider'></div>
            <PriceSummarySection title='קבלת הזמנה' />
            {isCourier ? (
              <div className='info'>
                <span className='detail'>
                  השליח יגיע ב{deliveryInfo.deliveryHebrewDayOfTheWeek}, {deliveryInfo?.deliveryDate} בין {deliveryInfo?.deliveryRange[0]}
                  -{deliveryInfo?.deliveryRange[1]}
                </span>
                <span className='detail'>לכתובת {deliveryInfo?.address}</span>
                {(!store.isSimInMailBox && !isNullOrEmpty(deliveryInfo?.recipientPhoneNumber)) && (
                  <span className='detail'>
                    יקבל את השליח {deliveryInfo?.recipientName} {deliveryInfo.recipientPhoneNumber}
                  </span>
                )}
              </div>
            ) : (
              <div className='info'>
                <span className='detail'>{store?.orderDetails?.pickUpDetails?.pickupDistributionCenterName}</span>
                <span className='detail'>{store?.orderDetails?.pickUpDetails?.pickupDistributionCenterAddress}</span>
                {/* <span className='detail'>{formatActivityHours(store.pickupServiceCenter?.activity_hours)}</span> */}
              </div>
            )}
          </>
        )}

        <>
          <div className='divider'></div>
          <PriceSummarySection title='סיכום ההזמנה נשלח לדוא"ל' />
          <div className='info'>
            <span className=''>{store.orderDetails.email}</span>
          </div>

          <div className='action-btns-container'>
            <BtnWhiteBlackBorderSmallSize text='שמירה כתמונה' onclick={capturePage} />
            {isCourier && (
              <BtnWhiteBlackBorderSmallSize text='הוספת תזכורת ליומן' onclick={handleAddToCalenderClick} />
            )}
          </div>
        </>

      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  idfStore: state.idfSale,
  auth: state.authentication,
});

const mapDispatchToProps = {
  saveToHistory,
  pushToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary);
